
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book-a-viewing",
      function () {
        return require("private-next-pages/book-a-viewing/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book-a-viewing"])
      });
    }
  